import React from "react";
const Features = () => {
  return <>Features Page</>;
};

export default Features;
